<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title
                >{{ `${$route.meta.title}` | t
                }}<span style="color:gray;">{{ ` (${invoiceCount})` }}</span></v-toolbar-title
            >
            <v-combobox
                v-if="hasPermissionForAction(PermissionsConstants.EXPORT, PermissionsConstants.SEARCH)"
                :items="searchHistory"
                :value="searchInvoiceString"
                @input="controlSearchString($event)"
                item-text="keyword"
                id="searchInput"
                class="mt-6 mx-2"
                :placeholder="'Shop name, company, type, city, product name, product code' | t"
                prepend-inner-icon="search"
                flat
                solo
                dense
                clearable
            >
                <template slot="item" slot-scope="data">
                    <span
                        @click="updateProductSearch(data.item.keyword)"
                        style="width: 100%; height: 100%"
                        class="pa-2"
                        >{{ data.item.keyword }}</span
                    >
                </template>
            </v-combobox>
            <v-spacer v-else />
            <v-btn
                dark
                color="bal-dark-gray"
                class="px-2"
                @click.stop="toggleListSettingsModal"
                v-if="hasPermissionForAction(PermissionsConstants.EXPORT, PermissionsConstants.FILTER)"
                style="min-width: 0;"
            >
                <v-icon>settings</v-icon>
            </v-btn>
            <v-btn
                dark
                color="bal-red"
                class="px-2 ml-2"
                @click.stop="openNewInvoiceDrawer"
                v-if="hasPermissionForAction(PermissionsConstants.EXPORT, PermissionsConstants.CREATE)"
                style="min-width: 0;"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" @close="toggleDrawer" />

        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="1000">
            <export-sale-invoice-view v-if="$route.name === 'export-sale-invoice-view'"></export-sale-invoice-view>
            <export-sale-invoice-edit v-if="$route.name === 'export-sale-invoice-edit'"></export-sale-invoice-edit>
        </v-navigation-drawer>
        <!-- Main content -->
        <v-main>
            <export-sale-invoice-list />
        </v-main>
        <export-sale-invoice-list-settings-modal />
        <!-- Success snackbar -->
        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>

        <!-- Error snackbar -->
        <v-snackbar color="error" bottom :timeout="2500" :value="requestError">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2 ">{{ errorMessage }}</div>
            </div>
        </v-snackbar>
        <!-- Footer -->
        <page-footer />
    </v-app>
</template>

<script>
import ExportSaleInvoiceList from "@/pages/export-sale-invoice/export-sale-invoice-list";
import ExportSaleInvoiceEdit from "@/pages/export-sale-invoice/export-sale-invoice-edit";
import ExportSaleInvoiceView from "@/pages/export-sale-invoice/export-sale-invoice-view";
import PageFooter from "@/components/page-footer";
import MainDrawer from "@/components/main-drawer";
import { mapGetters, mapMutations, mapState } from "vuex";
import Store from "@/store";
import ExportSaleInvoiceListSettingsModal from "@/pages/export-sale-invoice/export-sale-invoice-list-settings-modal";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "export-sale-invoice",
    components: {
        ExportSaleInvoiceListSettingsModal,
        ExportSaleInvoiceList,
        ExportSaleInvoiceEdit,
        ExportSaleInvoiceView,
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null,
            test: false
        };
    },
    async created() {
        await Store.dispatch("SearchHistoryStore/getSearchHistory", this.$route.path.replace("/", ""));
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
    },
    destroyed() {
        if (this.searchInvoiceString.length > 0) Store.commit("ExportSaleInvoiceStore/resetInvoiceSearch");
        document.removeEventListener("keydown", this.handleKeyboardListener);
        Store.commit("ExportSaleInvoiceStore/setRequestSuccess", false);
        Store.commit("ExportSaleInvoiceStore/setErrorMessage", "");
    },
    watch: {
        requestSuccess: value => {
            if (value) setTimeout(() => Store.commit("ExportSaleInvoiceStore/setRequestSuccess", false), 2500);
        },
        requestError: value => {
            if (value)
                setTimeout(() => {
                    Store.commit("ExportSaleInvoiceStore/setRequestError", false);
                    Store.commit("ExportSaleInvoiceStore/setErrorMessage", "");
                }, 2500);
        }
    },
    methods: {
        ...mapMutations("ExportSaleInvoiceStore", [
            "toggleListSettingsModal",
            "setRequestSuccess",
            "setErrorMessage",
            "setRequestError"
        ]),
        openNewInvoiceDrawer() {
            this.$router.push({ name: "export-sale-invoice-edit", params: { exportInvoiceId: "new" } });
        },
        updateProductSearch(value) {
            Store.commit("ExportSaleInvoiceStore/updateInvoiceSearch", { term: value });
        },
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.imageFileDialog) {
                Store.commit("ExportSaleInvoiceStore/setImageFileDialog", false);
            } else if (e.keyCode === 27 && this.drawerOpen) {
                this.$router.push({ name: "export-sale-invoice-list" });
            } else if (e.keyCode === 13 && document.activeElement.tagName === "INPUT") {
                Store.commit("ExportSaleInvoiceStore/updateInvoiceSearch", {
                    term: document.querySelector("#searchInput").value
                });
            }
            if (
                this.activeExportInvoice &&
                Object.keys(this.activeExportInvoice).length > 0 &&
                this.activeExportInvoice.id !== "new" &&
                this.$route.name !== "export-sale-invoice-edit" &&
                !this.exportInvoiceDialog &&
                document.activeElement.tagName !== "TEXTAREA"
            ) {
                let currentProductIndex = this.exportInvoices.findIndex(p => p.id === this.activeExportInvoice.id);
                if (e.key === "ArrowUp") {
                    if (currentProductIndex !== 0) {
                        const newInvoiceId = this.exportInvoices[currentProductIndex - 1].id;
                        Store.dispatch("ExportSaleInvoiceStore/getExportInvoiceData", newInvoiceId);
                        this.$router.push({ name: this.$route.name, params: { exportInvoiceId: newInvoiceId } });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentProductIndex + 1 !== this.exportInvoices.length) {
                        const newInvoiceId = this.exportInvoices[currentProductIndex + 1].id;
                        Store.dispatch("ExportSaleInvoiceStore/getExportInvoiceData", newInvoiceId);
                        this.$router.push({ name: this.$route.name, params: { exportInvoiceId: newInvoiceId } });
                    }
                }
            }
        },
        controlSearchString(value) {
            if (value == "") {
                Store.dispatch("SearchHistoryStore/getSearchHistory", this.$route.path.replace("/", ""));
                this.updateProductSearch(value);
            }
        }
    },
    computed: {
        ...mapState("ExportSaleInvoiceStore", [
            "drawerOpen",
            "requestSuccess",
            "requestError",
            "errorMessage",
            "searchInvoiceString",
            "activeExportInvoice",
            "exportInvoices",
            "imageFileDialog"
        ]),
        ...mapGetters("ExportSaleInvoiceStore", ["invoiceCount"]),
        ...mapState("SearchHistoryStore", ["searchHistory"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    }
};
</script>

<style scoped></style>
